<template>
  <div>
    <form class="lm-forms">
      <slot name="modal-header">
        <header class="modal-card-head">
          <b-icon
            :icon="content.icon"
            size="is-small"
          />
          <div
            class="lr-modal-title"
            v-t="content.title + body.orderCodes"
          />
        </header>
      </slot>
      <slot name="modal-main">
        <main class="modal-card-body">
          <component
            :is="component"
            v-if="component"
            v-bind="content"
          />
        </main>
      </slot>
      <slot name="modal-footer">
        <footer class="modal-card-foot">
          <div class="buttons">
            <b-button
              class="lm-default-btn-outline-green"
              v-t="'Common.cancel'"
              @click.prevent="handleClick"
            />
          </div>
          <div class="buttons local-lr-pull-right">
            <b-button
              class="lm-default-btn-outline-green"
              v-t="'Common.confirm'"
              :disabled="disabled"
              @click.prevent="submitData"
            />
          </div>
        </footer>
      </slot>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mixin } from '@/mixins'

export default {
  name: 'ModalFactory',
  mixins: [
    mixin.notifications,
    mixin.dates
  ],
  computed: {
    ...mapGetters('modal', [
      'content'
    ]),
    loadComponent () {
      if (!this.content.component) return null

      return () => import(`./modals/${this.content.component}`)
    },
    body () {
      return this.content.body
    },
    type () {
      return this.content.type
    }
  },
  data () {
    return {
      component: null,
      childData: null,
      disabled: true
    }
  },
  mounted () {
    this.component = () => this.loadComponent()

    this.$eventBus.$on('modalChanges', async (changes, error) => {
      if (!error) this.childData = changes
      this.disabled = error
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('modalChanges')
  },
  methods: {
    handleClick () {
      this.$eventBus.$emit('closeModal')
    },
    async submitData () {
      const filters = await this.$store.getters['modal/filtersSelected']
      const orderIds = this.type.name === 'TO_REVERT_SUPPLIER' ? this.childData.id : this.body.orderIds
      const params = {
        data: { ...this.childData, ...filters },
        orders: orderIds,
        type: this.type.name
      }

      if (this.type.name === 'TO_REJECT' && params.data.form.newDate) params.data.dateReason = `${this.dateFormat(params.data.form.dateReason)} 00:00`

      const applyChanges = async params => {
        switch (params.type) {
          case 'TO_REVERT_SUPPLIER':
            const revertResults = await this.$store.dispatch('orders/setSpecialActionsRestoreOrder', { orderIds })
            return revertResults
          case 'TO_REJECT':
            const rejectResults = await this.$store.dispatch('orders/setSpecialActionsRejectOrder', params)
            return rejectResults
          default:
            const editResults = await this.$store.dispatch('orders/setEditChanges', params)
            return editResults
        }
      }

      const changes = await applyChanges(params)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      if (params.type === 'TO_REVERT_SUPPLIER') {
        this.$eventBus.$emit('removeRestoreControl', this.childData)
        this.$eventBus.$emit('getAvailableOrders')
      }

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalFactory.vue